module.exports = __webpack_public_path__ + "static/appstoreWhiteDeu-e910821ec725f498a3000083b90282f3.svg";